import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { FormAlignmentsEnum } from '../../form-master.enum';
import { FormFieldComponent } from '../form-field/form-field.component';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-toggle-field',
  templateUrl: 'toggle-field.component.html',
  styleUrls: ['toggle-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleFieldComponent extends FormFieldComponent implements OnInit {
  @Input() alignment: FormAlignmentsEnum;
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() hideToggleButton = false;
  @Input() description: string;
  @Input() fieldId: string;
  @Input() fieldControl: AbstractControl;
  @Input() icon: IIcon;
  @Input() toggleInputE2eId: string;
  @Input() toggleLabelE2eId: string;
  @Input() labelE2eId: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingIdentifier: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingAdditionalProperties: any;

  @Output() onClick: EventEmitter<Event> = new EventEmitter<Event>();
  @Output() onClickIcon: EventEmitter<void> = new EventEmitter<void>();

  lockIcon: IIcon;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    translateService: TranslateService
  ) {
    super(changeDetectorRef, translateService);
  }

  ngOnInit() {
    this.lockIcon = {
      name: 'lock',
      size: IconSizesEnum.custom,
    };
  }
}
